import {
  standardRequestWithErrorFlash,
  standardRequestWithFlash,
} from '../../../shared/utils/request';
import type { Alerts } from '../types';

export const fetchAlerts = async (
  alertsPath: string
): Promise<{ alerts: Alerts }> => {
  const result = await standardRequestWithFlash.get(alertsPath);
  return result.data;
};

export const dismissDuplicateAlert = async (path: string) => {
  const result = await standardRequestWithErrorFlash.post(path);
  return result.data;
};
